import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    padding: 16px 0;

    .icon {
      margin-right: 16px;
      width: 40px;
      display: flex;
      align-items: flex-start;

      .image {
        width: 40px;
        border-radius: 50%;
        height: 40px;
        object-fit: cover;
      }
    }

    .info {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .info .title {
      color: ${theme.colors.colorGray400};
      font-size: 16px;
      line-height: 19px;
      font-weight: 500;
    }

    .info .subtitle {
      color: ${theme.colors.colorGray500};
      font-size: 18px;
      font-weight: 500;
      line-height: 22px;
      margin-top: 2px;
    }

    .info .aditional {
      color: ${theme.colors.colorGray400};
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
    }

    .info .link {
      color: ${theme.colors.blueEinstein};
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      display: flex;
      align-items: center;
      gap: 12px;

      img {
        height: 26px;
      }
    }
  `}
`;
